import { combineEpics, Epic, ofType, StateObservable } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, delay, filter, map, mapTo, switchMap, takeUntil } from 'rxjs/operators';
import { getType } from 'typesafe-actions';

import { ApiMethodExecutingError } from '../../service/Errors';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';
import { FetchIdeasApiResponse } from '../api/IdeasMethodExecutor/IdeasMethodExecutor';
import { CanvasAction } from '../common/actions';

import { FetchIdeas, fetchIdeas, fetchIdeasError, fetchIdeasSuccess, increaseFetchIdeasStep } from './actions';
import { mapResponseToIdeas } from './mappers';

// значения таймаутов переехали сюда из репозитория canvas, концов почему они именно такие уже не найти
// можно предполагать, что подобраны эмпирически
const TIMEOUT_TO_NEXT_STEP = [
    // step0 -> step1
    60 * 1000,
    // step1 -> step2
    120 * 1000
];

export const fetchIdeasEpic: Epic<CanvasAction, CanvasAction, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(getType(fetchIdeas)),
        switchMap(
            (action: FetchIdeas): Observable<CanvasAction> => {
                const { sharedData } = store$.value.canvasEditor;

                return from(deps.canvasApi.ideas.fetchIdeasCreatives(action.source, sharedData)).pipe(
                    map((fetchResult: FetchIdeasApiResponse) => {
                        const itemsPrepared = mapResponseToIdeas(fetchResult);

                        return fetchIdeasSuccess(fetchResult.url, fetchResult.ideaId, itemsPrepared);
                    }),
                    catchError((error: ApiMethodExecutingError) => of(fetchIdeasError(error.getNativeError().message)))
                );
            }
        )
    );
};

const needIncreaseProgressStep = (action$: Observable<CanvasAction>, store$: StateObservable<State>) => {
    return takeUntil(
        action$.pipe(
            filter(() => store$.value.canvasEditor.canvas.ideasList.progressStep < TIMEOUT_TO_NEXT_STEP.length),
            ofType(getType(fetchIdeasSuccess), getType(fetchIdeasError))
        )
    );
};

export const fetchIdeasProgressEpic: Epic<CanvasAction, CanvasAction, State> = (action$, store$) => {
    return action$.pipe(
        ofType(getType(fetchIdeas), getType(increaseFetchIdeasStep)),
        switchMap(
            (action): Observable<CanvasAction> => {
                const currentStep = store$.value.canvasEditor.canvas.ideasList.progressStep;

                return of(action).pipe(
                    needIncreaseProgressStep(action$, store$),
                    delay(TIMEOUT_TO_NEXT_STEP[currentStep]),
                    needIncreaseProgressStep(action$, store$),
                    mapTo(increaseFetchIdeasStep())
                );
            }
        )
    );
};

export const ideasEpic = combineEpics(fetchIdeasProgressEpic, fetchIdeasEpic);
